<template>
<div class="alles-sortieren">
    <ZugStepper :anzahl="uebung.zuege.length" :aktuell="erledigt.length" />
    <AblaufKopf :uebung="uebung" />


    <!-- Fertige Zuege: stehen als Spruch da, nicht mehr veraenderbar.
         Wie die Tabelle im Behelf, nur in einer Spalte: jede Station hat
         ihren eigenen Einzug. -->
    <div v-for="z in erledigt" :key="z.nr" class="erledigt" :style="einzug(z)">
        <p class="station nur-vorlesen">{{ z.station.rufname }}</p>
        <p class="spruch">{{ spruchVon(z) }}</p>
    </div>

    <!-- Wer spricht, nur wenn es mehr als einen Zug gibt. Beim Grundschema
         sagt das schon die Lage. -->
    <p v-if="uebung.zuege.length > 1" class="station" :style="{ marginLeft: einzug(zug).marginLeft }">{{ zug.station.rufname }}</p>

    <ZugSortieren
        :key="zug.nr"
        :zug="zug"
        :mit-ablenkern="mitAblenkern"
        :rueckmeldung="rueckmeldung"
        :leer-sperren="leerSperren"
        @pruefen="pruefen"
        @geaendert="rueckmeldung = null">
        <template #rechts><slot name="rechts" /></template>
    </ZugSortieren>

</div>
</template>

<script>
import { ref, computed } from 'vue';
import AblaufKopf from '@/components/AblaufKopf.vue';
import ZugStepper from '@/components/ZugStepper.vue';
import { pruefe } from '@/logic/Uebung';
import { einzugFuer } from '@/logic/Einzug';
import ZugSortieren from '@/components/ZugSortieren.vue';

// Uebungsart "Alles sortieren": jeder Zug des Ablaufs wird aus Bausteinen
// gebaut, einer nach dem anderen. Sitzt ein Zug, steht er fest und der
// naechste kommt. Sitzt der letzte, ist die Uebung geloest.
//
// Vertrag mit dem Container (gilt fuer jede Uebungsart):
//   Prop  uebung     — ein Ergebnis von baueUebung()
//   Event geprueft   — bei jedem Pruefen, Nutzlast { sitzt, geloest }:
//                      sitzt = der gepruefte Zug, geloest = die ganze Uebung
// Von einer Sitzung weiss diese Komponente nichts.
export default {
    components: { ZugSortieren, AblaufKopf, ZugStepper },
    props: {
        uebung: {type: Object, required: true},
        mitAblenkern: {type: Boolean, default: false},
        leerSperren: {type: Boolean, default: false}
    },
    emits: ['geprueft'],
    setup(props, { emit }) {
        const aktuell = ref(0)
        const zug = computed(() => props.uebung.zuege[aktuell.value])
        const erledigt = computed(() => props.uebung.zuege.slice(0, aktuell.value))

        // Rueckmeldung ist ein ref, KEIN computed: ein computed wuerde bei
        // jeder Bewegung neu rechnen und die Antwort live benoten. Sie darf
        // nur auf "Pruefen" hin entstehen und bei jeder Aenderung vergehen.
        const rueckmeldung = ref(null)

        const spruchVon = (z) => z.teile.map(t => t.text).join(' ')

        const einzug = einzugFuer(props.uebung)

        // Der Set entfernt doppelte Regeln, filter(Boolean) die null-Hinweise
        // der richtig liegenden Bausteine.
        const pruefen = (ablage) => {
            const ergebnis = pruefe(ablage, zug.value)
            const letzter = aktuell.value === props.uebung.zuege.length - 1

            emit('geprueft', { sitzt: ergebnis.sitzt, geloest: ergebnis.sitzt && letzter })

            if (ergebnis.sitzt && !letzter) {
                aktuell.value += 1
                rueckmeldung.value = null
                return
            }
            rueckmeldung.value = {
                sitzt: ergebnis.sitzt,
                spruch: ablage.map(t => t.text).join(' '),
                regeln: [...new Set(ergebnis.bausteine.map(b => b.hinweis).filter(Boolean))]
            }
        }

        return { zug, erledigt, rueckmeldung, spruchVon, einzug, pruefen }
    }
}
</script>

<style scoped>
/* Station = Farbe Blau, wie ueberall: Farbe steht fuer Station oder fuer
   richtig/falsch, fuer nichts sonst. */
.station {
    margin: 0 0 0.75rem;
    font-size: 0.8rem;
    font-weight: 650;
    color: var(--zs-blau);
}

/* Fertige Zuege: stehen fest, olivgruen = richtig. */
.erledigt {
    margin: 0 0 1rem;
    padding: 0.7rem 0.9rem;
    background: var(--zs-oliv-hell);
    border: 1px solid rgba(85, 107, 47, 0.4);
    border-radius: var(--zs-ecke);
}

.erledigt .spruch {
    margin: 0;
    line-height: 1.45;
}

/* Funktext in fester Laufweite: Protokolltext, nicht Bedientext. */
.erledigt .spruch {
    font-family: var(--zs-funkschrift);
}
</style>
